// PRC-026: esqueleto de la aplicación (menú lateral y cabecera en gris, sin
// datos) mientras carga la cuenta por primera vez en este navegador.
import React from 'react';
import { Box } from '@mui/material';
import { J } from '../journeyTokens';

const Bar: React.FC<{ w: number | string; h?: number; sx?: object }> = ({ w, h = 12, sx }) => (
  <Box sx={{ width: w, height: h, borderRadius: '6px', bgcolor: 'rgba(148,163,184,.10)', ...sx }} />
);

const AppSkeleton: React.FC = () => (
  <Box aria-busy="true" aria-label="Cargando" sx={{ display: 'flex', minHeight: '100vh', bgcolor: J.bg }}>
    <Box sx={{ display: { xs: 'none', lg: 'flex' }, flexDirection: 'column', gap: 2, width: 72, flexShrink: 0, bgcolor: J.panel, borderRight: `1px solid ${J.border}`, alignItems: 'center', py: 2.5 }}>
      <Bar w={34} h={34} sx={{ borderRadius: '10px', mb: 2 }} />
      {[0, 1, 2, 3, 4].map((i) => <Bar key={i} w={40} h={40} sx={{ borderRadius: '10px' }} />)}
      <Box sx={{ flex: 1 }} />
      <Bar w={40} h={40} sx={{ borderRadius: '50%' }} />
    </Box>
    <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ height: 64, display: 'flex', alignItems: 'center', px: { xs: 2, md: 4 }, borderBottom: `1px solid ${J.border}`, gap: 2 }}>
        <Bar w={180} />
        <Box sx={{ flex: 1 }} />
        <Bar w={36} h={36} sx={{ borderRadius: '50%' }} />
      </Box>
      <Box sx={{ p: { xs: 2, md: 4 }, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Bar w={260} h={28} />
        <Bar w="40%" />
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0,1fr))' }, gap: 2, mt: 2 }}>
          {[0, 1, 2].map((i) => <Bar key={i} w="100%" h={110} sx={{ borderRadius: '16px' }} />)}
        </Box>
        <Bar w="100%" h={280} sx={{ borderRadius: '16px', mt: 1 }} />
      </Box>
    </Box>
  </Box>
);

export default AppSkeleton;
